import Box from "@mui/material/Box";

// Decorative navy overlay — clips to an ellipse shape for the card header
const ChartOverlay = ({ width = "100%", height = "100%" }) => (
    <Box
        sx={{
            width,
            height,
            backgroundColor: "primary.main",
            clipPath: "ellipse(101% 74% at -5% 26%)",
        }}
    />
);

export default ChartOverlay;